import type { VehicleInfoSuggestion, VehicleSuggestionAPI } from './Types';

export const VehicleSuggestionAPIToVehicleSuggestion = (suggestionAPI: VehicleSuggestionAPI): VehicleInfoSuggestion => ({
  plate: suggestionAPI.plate,
  brand: suggestionAPI.make,
  model: suggestionAPI.model,
  year: suggestionAPI.year,
});

export default VehicleSuggestionAPIToVehicleSuggestion;
